import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import check from "../assets/images/check.svg";
import CloseIcon from "@mui/icons-material/Close";

type VerifiedPopupProps = {
  open: boolean;
  onClose: () => void;
  label: string;
  text?: string;
};

const VerifiedPopup: React.FC<VerifiedPopupProps> = ({
  open,
  onClose,
  label,
  text,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return; // ignore clicks outside and escape key
        }
        onClose();
      }}
      disableEscapeKeyDown
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "visible",
          // Responsive pass (F.9): 450x250 fixed px overflowed handheld
          // viewports. sm and up is byte-identical to before.
          px: { xs: 2.5, sm: 4 },
          pt: 6,
          pb: 3,
          position: "relative",
          boxShadow: 5,
          borderBottom: `6px solid #20BF55`,
          height: { xs: "auto", sm: 250 },
          minHeight: { xs: 220, sm: 250 },
          width: { xs: "100%", sm: 450 },
          maxWidth: "100%",
          m: { xs: 2, sm: 4 },
        },
      }}
    >
      {/* Green Circle Icon */}
      <Box
        sx={{
          position: "absolute",
          top: -60,
          left: "50%",
          transform: "translateX(-50%)",
          width: 125,
          height: 125,
          borderRadius: "50%",
          backgroundColor: "background.default",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "inset 0 0 12px rgba(0, 0, 0, 0.2)",
        }}
      >
        <img
          src={check}
          alt="Logo"
          style={{ height: 70, width: 70, objectFit: "contain" }}
        />
      </Box>
      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={1}
        >
          <Typography fontSize={38} fontWeight={600} color="#20BF55">
            {label}
          </Typography>
          <Typography fontSize={16} fontWeight={400} color="text.secondary">
            {text}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default VerifiedPopup;
